/**
 * Client-Hilfen für Rechnungsnummer in SmartSearch buildKeys.
 * (Spiegel von utils/invoiceSearch.js – Vite bundelt ohne Root-utils-Import.)
 */

export function extractInvoiceDigits(value) {
  return String(value ?? "").replace(/\D/g, "");
}

export function stripInvoicePrefix(value) {
  return String(value ?? "")
    .trim()
    .replace(/^(rg|rechnung|inv|invoice|proforma)\s*[-#:.]?\s*/i, "")
    .trim();
}

export function shouldUseInvoiceDigitMatch(token) {
  const t = String(token ?? "").trim();
  if (!t) return false;
  if (/^\d{3,}$/.test(t)) return true;
  return extractInvoiceDigits(t).length >= 3;
}

export function appendInvoiceSearchKeys(keys, ...values) {
  const out = Array.isArray(keys) ? [...keys] : [];
  for (const v of values) {
    const raw = String(v ?? "").trim();
    if (!raw) continue;
    out.push(raw);
    const stripped = stripInvoicePrefix(raw);
    if (stripped && stripped !== raw) out.push(stripped);
    const digits = extractInvoiceDigits(raw);
    if (digits.length >= 2) out.push(digits);
    if (stripped) {
      const d2 = extractInvoiceDigits(stripped);
      if (d2.length >= 2 && d2 !== digits) out.push(d2);
    }
  }
  return out;
}
